import { snakeCase } from 'lodash';
import T from 'i18n-react';

export function toOptionsArray(arr) {
  return arr ? arr.map(el => {return { value: snakeCase(el), label: T.translate(el), key: el };}) : [];
}
